import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPG: CultureInfo = {
  name: 'en-PG',
  displayName: 'English (Papua New Guinea)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PG',
  parent: CultureInfoEn
};
